import core from "@/helpers/client";
const groupViewPermissionService = {
  async updateGroupViewPermission(applicationId,groupId,viewId, body) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/applications/${applicationId}/groups/${groupId}/views/${viewId}/permissions`,
      body
    );
    return result;
  },
  async deleteGroupViewPermission(applicationId,groupId,viewId) {
    const result = await core.delete(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/applications/${applicationId}/groups/${groupId}/views/${viewId}`
    );
    return result;
  },
};
export default groupViewPermissionService;
